import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { applyFontScale } from './utils/fontScale';
import { activarTeclado } from './utils/teclado';
import { aplicarTema } from './utils/tema';

// Aplica el tamaño de letra y el tema guardados antes de renderizar (evita el parpadeo).
applyFontScale();
aplicarTema();
activarTeclado();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
